import React from 'react';
import {Divider} from 'antd';
import { Link } from 'dva/router';
import HTMLEllipsis from 'react-lines-ellipsis/lib/html';

export default ({novel_id, name, author, cata, brief}) => ( 
    <div style={{
        height: '136px',
        position: 'relative',
    }}>
        <Link to={`/book/detail/${novel_id}`}>
            <div style={{
                fontSize: '16px',
                lineHeight: '22px',
                color: '#333333',
            }}>{name}</div>
            <div style={{
                marginTop: '7px',
                fontSize: '12px',
                lineHeight: '17px',
                color: '#999999',
            }}>
            {cata}<Divider type="vertical" />{author}
            </div>
            <div style={{
                marginTop: '10px',
                fontSize: '14px',
                lineHeight: '20px',
                color: '#999999',
            }}>
                <HTMLEllipsis unsafeHTML={(brief||'').split('\n').map((text,idx)=>(`<div key=${idx}>${text}</div>`))} maxLine={3} />
            </div>
        </Link>
    </div>
)



// WEBPACK FOOTER //
// ./src/component/book/styl_brief_2.js